import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FileDownloadService } from './file-download.service';
import { DomSanitizer } from '@angular/platform-browser';
import { isSafeUrl } from '@utils/html-sanitizer.util';

@Injectable({
  providedIn: 'root'
})
export class DadosUsuarioService {

  constructor(private readonly http: HttpClient, private readonly domSanitizer: DomSanitizer) { }


  getAllUfs(){
    return this.http.get( `/apiconnect/importation/billing-address/states/companies`);
  }

  getAllDepartamentos ( id_empresa ){
    return this.http.get( `/apiconnect/importation/company/departament/${id_empresa}/companies`);
  }

  getAllCargos ( id_empresa) {
    return this.http.get( `/apiconnect/importation/company/responsibility/${id_empresa}/companies`);
  }

  getAllEnderecos ( id_empresa ) {
    return this.http.get( `/apiconnect/importation/billing-address/addresses/${id_empresa}/companies`);
  }

  // Esse será excluido mais pra frente quando reformular toda a tela de dados usuario
  getAllEnderecosFaturamento ( id_empresa ) {
    return this.http.get( `/apiconnect/importation/billing-address/${id_empresa}/companies`);
  }

  getDiasTrabalhados(id_empresa){
    return this.http.get( `/apiconnect/importation/benefit/work-days/${id_empresa}/companies`);

  }

  createUsuario (id_empresa: any, usuario){
    return this.http.post( `/apiconnect//importation/company/new-user/${id_empresa}/companies`, usuario);
  }

  uploadPhotoUsuario(idUsuario: number, foto: FormData) {
    return this.http.post(`/apiconnect/orders/photos?idUsuario=${idUsuario}`, foto);
  }

  getPhotoUsuario(idUsuario: number, sanitize = true) {
    return this.http.get(`/apiconnect/orders/photos/${idUsuario}/users`, {
      observe: 'response',
      responseType: 'blob',
    }).pipe(map(({body}) => {
      const url = FileDownloadService.generateUrl([body], { type: body.type })
      if (sanitize) {
        if (isSafeUrl(url)) {
          return this.domSanitizer.bypassSecurityTrustResourceUrl(url) // NOSONAR - S6268: URL validada por isSafeUrl(), aceita apenas URLs do tipo blob
        }
      }
      return url
    }));
  }

  createBeneficio ( beneficio ){
    return this.http.post( `/apiconnect/orders/users/benefits`, beneficio);
  }

  getAllBeneficios ( searchBeneficio : any) {
    return this.http.post( `/apiconnect/importation/benefit?valorCampo=${searchBeneficio}`, {});
  }

  getBenefitByIduser(id_usuario){
    return this.http.get(`/apiconnect/importation/users/benefits/${id_usuario}/users`);
  }

  createNewAddress(id_empresa: any, endereco){
    return this.http.post( `/apiconnect/importation/billing-address/data/${id_empresa}/companies`, endereco);
  }

  // Talvez tenha que pegar essa lista_cargos e arrumar pra quando enviar o cargo, pois pelo jeito não manda mais um array cheio de indices.
  createOfficeByIdEmpresa(id_empresa: any, lista_cargos: Array<string>){
    return this.http.get(`/apiconnect/importation/company/responsibility/new/${id_empresa}/companies?listaCargos=${lista_cargos}`);
  }

  // Talvez tenha que pegar essa lista_cargos e arrumar pra quando enviar o cargo, pois pelo jeito não manda mais um array cheio de indices.
  // Na verdade precisa dar um FOR e a cada departamento adicionar um listaDeoartamentos=o departamento
  createDepartmentByIdEmpresa(id_empresa: any, lista_departamento: Array<string>){
    return this.http.get(`/apiconnect/importation/company/departament/new/${id_empresa}/companies?listaDepartamentos=${lista_departamento}`);
  }

  searchCep(cep: string){
    return this.http.post(`/apiconnect/importation/billing-address/${cep}`, {});
  }

  gerarRelatorioOpcaoVt(idEmpresa: number, idUsuario: number) {
    // Ver se a base correta é importation/

    return this.http.get(`/apiconnect/report/options/${idEmpresa}/companies/${idUsuario}/useres`, {
      observe: 'response',
      responseType: 'text',
    });
  }

  // SERVIÇOS ROTA INTELIGENTE
  checkUserHasRotaInteligente(idEmpresa: any, idUsuario: number) {
    return this.http.get(`/apiconnect/importation/smart-route/check/${idEmpresa}/companies/${idUsuario}/scripting`);
  }

  consultaExcedente(idEmpresa: any) {
    return this.http.get(`/apiconnect/importation/smart-route/over/${idEmpresa}/companies`);
  }

  getDetailRoteirizacao(botao: string, idEmpresa: any, idUsuario: number) {

    let body = {
      "botaoSugestaoRota": botao,
      "idEmpresa": idEmpresa,
      "idUsuario": idUsuario
    }

    return this.http.post(`/apiconnect/importation/smart-route`, body);
  }

  getDataRotaInteligente(idEmpresa: any, idUsuario: number) {
    return this.http.get(`/apiconnect/importation/smart-route/scripting/${idEmpresa}/companies/${idUsuario}/users`);
  }

  getDetalhesRotaInteligente(idEmpresa: any, idUsuario: number, idRoteirizacao: number) {

    let body = {
        "idEmpresa": idEmpresa,
        "idRoteirizacao": idRoteirizacao,
        "idUsuario": idUsuario
    }

    return this.http.post(`/apiconnect/importation/smart-route/details`, body);

  }

  approvesRoteirizacao(idEmpresa: any, idRoteirizacao: any) {
    return this.http.get(`/apiconnect/importation/smart-route/${idEmpresa}/companies/${idRoteirizacao}/scripting`);
  }

  getHtmlRota(idEmpresa: any, idRoteirizacao: any, idUsuario: any){
    return this.http.get(`/apiconnect/report/smart-route/detail?idEmpresa=${idEmpresa}&idRoteirizacao=${idRoteirizacao}&idUsuario=${idUsuario}`);
  }

}
